import {
  NGENIUS_DEPOSIT,
  NGENIUS_DEPOSIT_SUCCESS,
  NGENIUS_DEPOSIT_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  details: [],
};

const ngeniusDepositReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case NGENIUS_DEPOSIT:
      return { ...state, loading: true };
    case NGENIUS_DEPOSIT_SUCCESS:
      return {
        ...state,
        details: action?.payload,
        loading: false,
      };
    case NGENIUS_DEPOSIT_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default ngeniusDepositReducer;
